import createModule from "../createModule"
import view from "./view"
import withUrlParams from "hocs/withUrlParams"
import { Creators } from "model/hookUpdater"
import { getRole } from "helpers/permissions/roles"
import { getDatasetEntitlementsEnabled } from "modules/account-root/selectors"
import { getTokenPermissions, getResources, getTabs } from "./selectors"

import "./styles.scss"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    tokenId: props.params.tokenId,
  }),
  required: ["account", "tokenId"],
  data: [{
    resource: "resources",
    url: () => {
      return {
        query: `{
          resources {
            id
            type
            alias
            name
            description
            updatedAt
            permissionLevel
          }
        }`,
      }
    },
  }, {
    resource: "tokenPermissions",
    url: ({ tokenId }) => {
      return {
        id: `token-permissions-${tokenId}`,
        query: `query ($tokenId: Id!) {
          token (id: $tokenId) {
            name
            resourcePermissions {
              id
              type
              name
              alias
              permissionLevel
              createdAt
              updatedAt
            }
          }
        }`,
        variables: {
          tokenId,
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    user: state.user,
    role: getRole(state, props),
    permissions: getTokenPermissions(state, props),
    resources: getResources(state, props),
    datasetEntitlementsEnabled: getDatasetEntitlementsEnabled(state, props),
    tabs: getTabs(state, props),
  }),
  actions: {
    ...Creators,
  },
}))
